// Used to throw when access token is missing or expired, before sending GraphQL requests
export class NotAuthenticatedError extends Error {}

export class EmptyShareError extends Error {
  message = 'Asset not found in share';
}

// Used to throw not found errors when massdriver does not return a not found response
export class NotFoundError extends Error {}
